import { render, staticRenderFns } from "./CampaignsBlockedClients.vue?vue&type=template&id=d7141ebe&"
import script from "./CampaignsBlockedClients.vue?vue&type=script&lang=js&"
export * from "./CampaignsBlockedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports